import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import Delivery from './Delivery.vue';
import Faq from './Faq.vue';
import Payment from './Payment.vue';
import Phone from './Phone.vue';
import Return from './Return.vue';
import TrustedShops from './TrustedShops.vue';
import TrustPilot from './TrustPilot.vue';
export default {
  name: 'Reinsurance',
  components: {
    Delivery,
    Faq,
    Payment,
    Phone,
    Return,
    TrustedShops,
    TrustPilot
  },

  data() {
    return {};
  },

  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  }), {
    defaultShowcase() {
      return this.locale.iso === 'fr-FR' || this.locale.iso === 'it-IT';
    }

  })
};